import Emitter from "./Emitter";
import gsap from "gsap";
import { Flip } from "gsap/Flip";
import SplitType from "split-type";
gsap.registerPlugin(Flip);

export default class Loading {
    constructor(enabled = true, pageName) {
        this.pageName = pageName;
        if (enabled) {
            if (pageName == 'home') {
                this.initHome()
            }
        } else {
            this.skip()
        }
    }

    initHome() {
        this.setup();
    }

    setup() {
        console.log('LOADING setting up')
        const splitSub = SplitType.create(document.querySelector('.loading .heading.--h3'), { types: 'chars', absolute: 'absolute' });
        const splitCopy = SplitType.create(document.querySelector('.loading .txt.--t12'), { types: 'chars', absolute: 'absolute' });
        gsap.set('.loading .heading.--h3 .char', { y: 10, 'filter': 'blur(4px)', autoAlpha: 0 })
        gsap.set('.loading .txt.--t12 .char', { y: 10, 'filter': 'blur(4px)', autoAlpha: 0 })
        gsap.set('.loading .logo', { y: 15, autoAlpha: 0 })
        this.start()
    }
    start() {
        const loadingTextItems = document.querySelectorAll('.loading .txt-item');
        const tl = gsap.timeline({
            onStart: () => {
                gsap.set('.loading-cover', { background: '#0e0e0e00' })
            },
            onComplete: () => {
                this.toHeader();
            }
        })
        tl.to('.loading .logo', { y: 0, autoAlpha: 1, duration: 1, delay: .2 })
            .to('.loading .heading.--h3 .char', { y: 0, 'filter': 'blur(0px)', duration: .5, autoAlpha: 1, stagger: .04 }, '.2')
            .to('.loading .txt.--t12 .char', { y: 0, 'filter': 'blur(0px)', duration: .5, autoAlpha: 1, stagger: .04 }, '.5')
        for (let x = 0; x < loadingTextItems.length; x++) {
            loadingTextItems[x].style.opacity = 1;
            const splitTxt = SplitType.create(loadingTextItems[x], { types: 'chars' });
            if (x == 0) {
                tl.from(splitTxt.chars, { y: 10, 'filter': 'blur(4px)', duration: .5, autoAlpha: 0, stagger: .04 }, '.4')
            } else {
                tl.from(splitTxt.chars, { y: 10, 'filter': 'blur(4px)', duration: .5, autoAlpha: 0, stagger: .04 }, `>-=${.1}`)
            }
            tl.to(splitTxt.chars, { y: 0, autoAlpha: 1, 'filter': 'blur(0px)', duration: .5 })
            if (x != loadingTextItems.length - 1) {
                tl.to(splitTxt.chars, { y: 14, 'filter': 'blur(4px)', autoAlpha: 0, duration: .4, stagger: .04 })
            }
        }
        this.tlLogo = gsap.timeline({})
        this.tlLogo.to('.loading .logo-typo', { rotate: 180, duration: tl.duration(), ease: 'none' })
    }
    toHeader() {
        const stateLogo = Flip.getState('.loading .logo .logo-inner');
        const logo = document.querySelector('.loading .logo .logo-inner');
        document.querySelector('.header .logo').append(logo);
        Flip.from(stateLogo, {
            absolute: true,
            duration: 1.6,
            delay: .2,
            onStart: () => {
                setTimeout(() => {
                    Emitter.emit('loading_done')
                }, 1.3);
            }
        });
        const tl = gsap.timeline({})
        tl
            .to('.loading .heading.--h3 .char', { y: 14, 'filter': 'blur(4px)', autoAlpha: 0, duration: .4, stagger: .04 }, '0')
            .to('.loading .txt-item:last-child .char', { y: 14, 'filter': 'blur(4px)', autoAlpha: 0, duration: .4, stagger: .04 }, '0')
            .to('.loading .txt.--t12 .char', { y: 14, 'filter': 'blur(4px)', autoAlpha: 0, duration: .4, stagger: .04 }, '<+=.2')
    }
    skip() {
        console.log('Skip loading')
        gsap.set('bp-loading', { display: 'none' })
        const logo = document.querySelector('.loading .logo .logo-inner');
        document.querySelector('.header .logo').append(logo);
        Emitter.on('resouces_Ready', () => {
            console.log('reseource readyyyyyy in loading');
        })
        setTimeout(() => {
            Emitter.emit('loading_done');
        }, 2500);
    }
}